module.exports = __webpack_public_path__ + "static/media/AMT.1feb6f84.svg";